export default __webpack_public_path__ + "static/media/plus__blue.e809217d.svg";